import request from '../index'
import { coreTechnologyMockList } from '@/views/home/childCpn/coreTechnologyMock'

//获取首页轮播图的url列表
export function getSwiperList() {
	return request({
		url: '/homeSwiper',
		method: 'get',
	})
}

/**
 * 获取首页-核心技术列表（固定 6 个模块）
 * 字段：name 模块名、features 功能描述(3条)、icon 右下角图标
 * 后台可编辑上述字段；前端仅展示前 6 条
 * TODO: 后台接口就绪后，去掉 mock，改为真实 request
 */
export function getHomeCoreTechnologyList() {
	// return request({
	// 	url: '/coreTechnology/list',
	// 	method: 'get',
	// 	params: {
	// 		page: 1,
	// 		pageNum: 6,
	// 	},
	// })
	return Promise.resolve({
		data: {
			code: 200,
			data: {
				list: coreTechnologyMockList,
			},
		},
	})
}
//获取首页-行业解决方案-领域列表
export function getHomeFieldList() {
	return request({
		url: '/plan/field',
		method: 'get',
		params: {
			page: 1,
			pageNum: 999,
		},
	})
}
/**
 * 获取官网-方案列表（公开接口，勿用 /manage/plans）
 * @param {number|string} [fieldId] 领域 id，不传则拉全部
 */
export function getHomePlanList(fieldId) {
	const params = {
		page: 1,
		pageNum: 999,
	}
	if (fieldId != null && fieldId !== '') {
		params.fieldId = fieldId
	}
	return request({
		url: '/plan/list',
		method: 'get',
		params,
	})
}
//获取首页-产品中心列表
export function getHomeProductList(id) {
	return request({
		url: '/product/list',
		method: 'get',
		params: {
			page: 1,
			pageNum: 999,
			seriesId: id,
		},
	})
}
//获取首页-成功案例列表
export function getHomeCaseList() {
	return request({
		url: '/case/list',
		method: 'get',
		params: {
			page: 1,
			pageNum: 999,
		},
	})
}
//获取首页新闻资讯列表
export function getHomeNewsList() {
	return request({
		url: '/newsList' + '?page=1&pageNum=3',
		method: 'get',
	})
}
//获取新闻资讯列表，包括缩略图和简述信息；可分页，可根据日期进行筛选。
export function getNewsList(data) {
	return request({
		url: '/newsList',
		method: 'get',
		params: {
			page: data.page,
			pageNum: data.pageNum,
			startTime: data.startTime,
			endTime: data.endTime,
			keyword: data.keyword,
		},
	})
}
//获取新闻详情
export function getNewsDetails(id) {
	return request({
		url: '/news' + '?id=' + id,
		method: 'get',
	})
}
